import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'navigatedFrom',
})
export class NavigatedFromPipe implements PipeTransform {

  transform(navigationState: any, defaultRouteName?: string, defaultRouteLink?: string): { name: string, link: string } {
    const navigatedFrom = navigationState?.navigatedFrom as string;
    if (!navigatedFrom) {
        return {name: defaultRouteName, link: defaultRouteLink};
    }

    const inventoryDetailsRoutePattern = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$';

    if (navigatedFrom.includes('/dashboard')) return {name: 'Home', link: navigatedFrom};
    else if (navigatedFrom.includes('/inventory/ndc')) return {name: 'Inventory', link: navigatedFrom};
    else if (navigatedFrom.match('/inventory/' + inventoryDetailsRoutePattern)?.length) {
        const drugName  = navigationState?.drugName;

        if (!drugName) throw Error('Drug name required for the route');

        return {name: drugName, link: navigatedFrom};
    }
    else if (navigatedFrom.includes('inventory/bulk-add')) return {name: 'Bulk Add', link: navigatedFrom};
    else if (navigatedFrom.includes('custom-report')) return {name: 'Custom Report', link: navigatedFrom};
    else if (navigatedFrom.includes('ndc-purchase-report')) return {name: 'NDC Purchase Report', link: navigatedFrom};
    else if (navigatedFrom.includes('reports/similar-on-hand-history')) return {name: 'Similar On-Hand History', link: navigatedFrom};
    else return {name: 'Back', link: navigatedFrom}
  }

}
